/** Exact decimal arithmetic for the publication comparison's presentation only.
 * Inputs have at most three decimal places in lb/MWh. Integer thousandths preserve every
 * digit; only the displayed answer is rounded, half away from zero, to one decimal place.
 * No conversion to JS number, no division of unlike units, no inventory/engine calculation.
 */
export function publicationComparison(
  parts: Readonly<{ co2: string; ch4: string; n2o: string; rev2: string }>,
  gwp: Readonly<{ co2: string; ch4: string; n2o: string }>,
) {
  function milli(value: string): bigint {
    if (!/^\d+(\.\d{1,3})?$/.test(value)) throw new Error("Unrecognised publication precision");
    const [whole, fraction = ""] = value.split(".");
    return BigInt(whole!) * 1000n + BigInt(fraction.padEnd(3, "0"));
  }
  function weight(value: string): bigint {
    if (!/^\d+$/.test(value)) throw new Error("Unrecognised GWP weight");
    return BigInt(value);
  }
  function display(value: bigint): string {
    const absolute = value < 0n ? -value : value;
    const tenths = (absolute + 50n) / 100n;
    return `${value < 0n && tenths !== 0n ? "−" : ""}${tenths / 10n}.${tenths % 10n}`;
  }
  const hub = milli(parts.co2) * weight(gwp.co2) + milli(parts.ch4) * weight(gwp.ch4) + milli(parts.n2o) * weight(gwp.n2o);
  const difference = hub - milli(parts.rev2);
  return { hub: display(hub), difference: `${difference >= 50n ? "+" : ""}${display(difference)}` };
}
